import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfMask'
})
export class CpfMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      value = value.replace(/\D/g, '');
      if(value.length === 11) {
        value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      return value;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/cpf-mask.pipe.ts
 **/